export const convertToCurrency = (price, currentCurrency, newCurrency, currencyTypes) => {
  const priceInBaseCurrency = price / currencyTypes[currentCurrency].rateVsBase
  const priceInNewCurrency = priceInBaseCurrency * currencyTypes[newCurrency].rateVsBase

  return priceInNewCurrency
}
